import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { Organisation } from '../../organisation/organisation.interface';
import { User } from '../../user/user.interface';
import {
  organisationById,
  organisationList,
  selectCurrentOrganizationID,
} from '../../organisation/organisation.selector';
import {
  loadOrganisationById,
  setCurrentOrganisationID,
} from '../../organisation/organisation.actions';
import { myUserId, userById } from '../../user/user.selector';
import { loadHome } from '../../home/home.actions';

@Component({
  selector: 'nw-global-header',
  templateUrl: './global-header.component.html',
  styleUrls: ['./global-header.component.scss'],
})
export class GlobalHeaderComponent implements OnInit {
  orgs$ = this.store.select(organisationList);
  currentOrgId$ = this.store.select(selectCurrentOrganizationID);
  currentOrg$: Observable<Organisation | undefined> = this.currentOrgId$.pipe(
    filter((id): id is string => !!id),
    switchMap(id => this.store.select(organisationById(id))),
  );

  myUserId$ = this.store.select(myUserId);
  myUser$: Observable<User> = this.myUserId$.pipe(
    filter((id): id is string => !!id),
    switchMap(id => this.store.select(userById(id))),
  );

  showOrgDropdown = false;

  @ViewChild('orgTrigger') orgTrigger?: ElementRef<HTMLElement>;
  @ViewChild('orgDropdown') orgDropdown?: ElementRef<HTMLElement>;

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(loadHome());

    combineLatest([this.orgs$, this.currentOrgId$])
      .pipe(
        tap(([orgs, currentId]) => {
          if (!currentId && orgs && orgs.length > 0) {
            this.store.dispatch(setCurrentOrganisationID({ ID: orgs[0].id }));
          }
        }),
      )
      .subscribe();

    this.currentOrgId$
      .pipe(filter((id): id is string => !!id))
      .subscribe(id => this.store.dispatch(loadOrganisationById({ id })));
  }

  toggleOrgDropdown() {
    this.showOrgDropdown = !this.showOrgDropdown;
  }

  onSelectOrg(id: string) {
    if (!id) return;
    this.store.dispatch(setCurrentOrganisationID({ ID: id }));
    this.showOrgDropdown = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.showOrgDropdown) return;
    const target = event.target as Node;
    const inTrigger = this.orgTrigger?.nativeElement.contains(target);
    const inDropdown = this.orgDropdown?.nativeElement?.contains(target);
    if (!inTrigger && !inDropdown) {
      this.showOrgDropdown = false;
    }
  }
}
